module.exports = __webpack_public_path__ + "static/media/Catalog.674a78a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/images/Catalog.svg
// module id = 947
// module chunks = 0